// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i3OL","question":"styles_question__34Xpq","inputVisibleButton":"styles_inputVisibleButton__3fR70","note":"styles_note__2Slha"};